
.s-quick-order{
  &-container{

  }
  &-button-cont{

  }
  // The collapsible content. Hidden by default
  &-expandable{
    &:not(.s-quick-order-shown){
      overflow: hidden;
    }
  }
  // Shown state of the collapsible content
  &-shown{

  }
  &-terms{

  }
  &-confirm{

  }
}